export type HistoryFamily = '2.0' | '3.0' | 'CSCA';
export type HistoryCategory = 'simulation' | 'past' | 'practice';
export interface ExamRestrictions {
  hsk2Levels: number[]; hsk3Levels: number[]; cscaLevels: number[];
  hsk2Restricted: boolean; hsk3Restricted: boolean; cscaRestricted: boolean;
}
export const historyFamilyLabel = (family: string) => family === 'CSCA' ? 'CSCA' : `HSK ${family}`;
export const historyCategories = (family: string): HistoryCategory[] => family === 'CSCA' ? ['past', 'simulation', 'practice'] : ['simulation', 'practice'];
export const historyCategoryLabel = (category: string) => category === 'past' ? '真题' : category === 'practice' ? '习题' : '模拟';
export const historyLevels = (r: ExamRestrictions, family: string) => family === 'CSCA' ? r.cscaLevels : family === '3.0' ? r.hsk3Levels : r.hsk2Levels;
export const defaultHistoryLevel = (r: ExamRestrictions, family: string) => {
  const levels = historyLevels(r, family);
  if (!levels.length) return 'all';
  return String(family === 'CSCA' ? (levels.includes(3) ? 3 : levels[0]) : Math.max(...levels));
};
export function historyAccess(r: ExamRestrictions) {
  const hsk2 = !r.hsk2Restricted && r.hsk2Levels.length > 0;
  const hsk3 = !r.hsk3Restricted && r.hsk3Levels.length > 0;
  const families: HistoryFamily[] = [];
  // Each granted family remains independently visible, including dual-HSK accounts.
  if (hsk2) families.push('2.0');
  if (hsk3) families.push('3.0');
  if (!r.cscaRestricted && r.cscaLevels.length) families.push('CSCA');
  return { families };
}
export function classifyHistory(t: { bank_version?: string; system_type?: string; level?: number; paper_year?: number; paper_month?: number; paper_id?: string }): HistoryCategory {
  const system = String(t.system_type || 'simulation').toLowerCase();
  if (['workbook', 'review', 'topic_practice', 'mooc_topic_practice', 'mooc_random'].includes(system)) return 'practice';
  if (t.bank_version === 'CSCA' && system === 'past_paper') {
    const review = Number(t.level) === 2 && Number(t.paper_year) === 2026 && [4, 6].includes(Number(t.paper_month));
    return review || /mock/i.test(t.paper_id || '') ? 'simulation' : 'past';
  }
  return 'simulation';
}
